import en from './locales/en.yml';
import ja from './locales/ja.yml';

export const locale = navigator.language.split('-')[0];
export default locale;

export const selectLocale = () => {
  switch (locale) {
    case 'en':
      return en;
    case 'ja':
      return ja;
    default:
      return ja;
  }
};
